module.exports = __webpack_public_path__ + "static/media/logo for Youth-white-01.0660a7d8.svg";